import { Stack } from '@mantine/core';
import {
  resetMeasureComparisonFilters,
  toggleMeasureSelection,
  toggleMeasureTrends,
} from '../../../../store/process-analysis-store/process-analysis-store.actions';
import {
  useGroupedMeasures,
  useSelectedMeasures,
  useSelectedMeasureTrends,
} from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { MeasureGroup } from '../../components/measure-filters/measure-group';
import { ResetFiltersButton } from '../../../../components/filters/reset-filters-button';
import { KEY_MEASURES } from '../../process-analysis.constants';

const MAX_SELECTED_MEASURES = 4;

export const MeasureComparison = () => {
  const groupedMeasures = useGroupedMeasures();
  const selectedMeasures = useSelectedMeasures();
  const selectedMeasureTrends = useSelectedMeasureTrends();

  return (
    <Stack pb={40}>
      {Object.entries(groupedMeasures).map(([groupName, measures], index) => (
        <MeasureGroup
          key={groupName}
          groupName={groupName}
          measures={measures}
          isFirst={index === 0}
          showTrends={true}
          selectedMeasures={selectedMeasures}
          selectedMeasureTrends={selectedMeasureTrends}
          maxSelectedMeasures={MAX_SELECTED_MEASURES}
          onMeasureToggle={toggleMeasureSelection}
          onTrendsToggle={toggleMeasureTrends}
        />
      ))}
      <ResetFiltersButton
        onClick={() => {
          resetMeasureComparisonFilters(KEY_MEASURES);
        }}
      />
    </Stack>
  );
};
